var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.enabled)?_c('billing-transfer-report'):_c('billing-professional-transfer-legacy')
}
var staticRenderFns = []

export { render, staticRenderFns }